// extracted by mini-css-extract-plugin
export default {"navbar":"ingredients-navbar_navbar__+sFjI"};